<div class="vertical__tabs--container">
    <div class="vertical__tabs--each" *ngFor="let eachTab of tabsList; let eachIndex = index;"
        [ngClass]="{'active': (eachIndex + 1) === selectedTab}"
        (click)="selectedTab = eachIndex + 1; tabChanged.emit(selectedTab);">
        <div class="vertical__tabs--count">{{eachIndex + 1}}</div>
        <div class="vertical__tabs--name">{{eachTab.label}}</div>
    </div>
</div>